import { render } from "./EditSubContract.vue?vue&type=template&id=07715798&scoped=true"
import script from "./EditSubContract.vue?vue&type=script&lang=js"
export * from "./EditSubContract.vue?vue&type=script&lang=js"

import "./EditSubContract.vue?vue&type=style&index=0&id=07715798&scoped=true&lang=css"

import exportComponent from "D:\\Work\\Contractly\\Contractly.Site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07715798"]])

export default __exports__